export const DynamicFieldType = {
  FORMS: 'Forms',
  LOAN_HEADER_VIEWS: 'LoanHeaderViews',
  EMAIL_SNIPPETS: 'EmailSnippets',
  EMAIL_SIGNATURES: 'EmailSignatures',
  EMAIL_TEMPLATES: 'EmailTemplates',
  ACCOUNT_EMAIL_TEMPLATES: 'AccountEmailTemplates',
};
